import { FaChevronDown } from 'react-icons/fa';

const FilterByCategory = (props) => {

    const {
        productCategoryData,
        subCategoryData,
        selectedCategories,
        handleCheckboxChange,
        filteredSubCategories,
        handleCategoryClick,
        expandedCategoryId,
        transitionState
    } = props;

    return (
        <div className="widget sidebar-tags">
            <div className="widget-title open">
                <h3 className="sidebar-title text-uppercase">
                    <span>Category</span>
                </h3>
            </div>
            <div className="widget-content d-block">
                {productCategoryData !== null ? (
                    productCategoryData.length > 0 ? (
                        <ul className="list-tags p-0 list-unstyled mb-4">
                            {productCategoryData.map((item, i) => {
                                const isExpanded = expandedCategoryId === item.productCategoryId;
                                const matchedSubCategories = subCategoryData?.filter(
                                    (sub) => sub.productCategoryId === item.productCategoryId && sub.isDisplay
                                );

                                if (matchedSubCategories?.length === 0) {
                                    return null;
                                }

                                return (
                                    <div className='filter_category_subcategory mb-2' key={i}>
                                        <li
                                            className="item cursor-pointer d-flex justify-content-between"
                                            onClick={() => handleCategoryClick(item.productCategoryId)}
                                        >
                                            <label className='cursor-pointer'>{item?.displayName}</label>
                                            {/* <span>{isExpanded ? <FaChevronUp /> : <FaChevronDown />}</span> */}
                                            <span>
                                                <FaChevronDown
                                                    className={`rotate-icon ${isExpanded ? "open" : ""}`}
                                                />
                                            </span>
                                        </li>

                                        <div
                                            className={`subcategory-wrapper ${expandedCategoryId === item.productCategoryId
                                                ? transitionState === 'open'
                                                    ? 'open'
                                                    : 'close'
                                                : ''
                                                }`}
                                        >
                                            {filteredSubCategories?.length > 0 ? (
                                                <ul>
                                                    {filteredSubCategories.map((element, j) => (
                                                        <li className="item_subcategory d-flex gap-2" key={j}>
                                                            <input
                                                                type="checkbox"
                                                                value={element.productSubCategoryId}
                                                                checked={selectedCategories.includes(element.productSubCategoryId)}
                                                                onChange={() => handleCheckboxChange(element.productSubCategoryId)}
                                                            />
                                                            <label>{element.displayName}</label>
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <p className='not_avaiable'>Item not available</p>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </ul>
                    ) : (
                        <p>No data available</p>
                    )
                ) : (
                    <p>Loading...</p>
                )}
            </div>
        </div>
    )
}

export default FilterByCategory;